<template>
  <div class="partner-id-container">
    <div class="sac__font-16 bold">Employer Identification Number/ Federal Tax ID</div>
    <div class="sac__font-16 med n70">
      Used for tax reporting and legal identification. Only visible to authorized users.
    </div>
    <div class="flex-row" style="flex-wrap: wrap">
      <div class="input-container">
        <div class="sac__font-14 med mt-4">Enter EIN</div>
        <SACInput
          field="ein"
          placeholder="XX-XXXXXXX"
          :value="ein"
          :change="handleChange"
          :error="errorObj.einErr"
        />
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import SACInput from '@shared/components/sac/SACInput.vue';

export default {
  name: 'PartnerEin',
  components: { SACInput, SACDropdown, SACCheckbox },
  mixins: [partnerSettingsMixin],
  props: {
    handleChange: Function,
    ein: String,
    errorObj: Object,
  },
};
</script>

<style lang="scss">
.partner-id-container {
  display: flex;
  flex-direction: column;
  border: 1px dashed $PRIMARY;
  padding: 15px;
}
.input-container {
  flex-direction: column;
  width: 440px;
  margin-right: 15px;
}
</style>
